export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo4-f018eb241db476867aafb10f3862c6f3.jpg";